import React from 'react';

import { useTranslation } from '@shared/core';
import { ConsoleEmptyState } from '@apps/stays/components/ConsoleEmptyState/ConsoleEmptyState';

type EmptyStateProps = Readonly<{
  onReset?: () => void;
  showResetButton?: boolean;
}>;

export const EmptyState = ({ onReset, showResetButton }: EmptyStateProps) => {
  const { t } = useTranslation('accommodationsConsole');
  const emptyStateTrans = t('emptyState');

  return (
    <ConsoleEmptyState
      onReset={onReset}
      title={emptyStateTrans.title()}
      showResetButton={showResetButton}
      content={emptyStateTrans.content()}
      resetButtonLabel={emptyStateTrans.buttonText()}
    />
  );
};
